function arrayToHeap(typedArray, module) {
    var numBytes = typedArray.length * typedArray.BYTES_PER_ELEMENT;
    var ptr = module._malloc(numBytes);
    var heapBytes = new Uint8Array(module.HEAPU8.buffer, ptr, numBytes);
    heapBytes.set(new Uint8Array(typedArray.buffer));
    return heapBytes;
}
function heapToFloat64Array(heapBytes, array) {
    return new Float64Array(
        heapBytes.buffer,
        heapBytes.byteOffset,
        heapBytes.length / array.BYTES_PER_ELEMENT);
}
function heapToInt32Array(heapBytes, array) {
    return new Int32Array(
        heapBytes.buffer,
        heapBytes.byteOffset,
        heapBytes.length / array.BYTES_PER_ELEMENT);
}
function freeArray(heapBytes, module) {
    module._free(heapBytes.byteOffset);
}

export const wasmComputation = (a2D,module) => {

    console.log('wasm start')
    console.log(a2D)

    var u = [];
    var u_size = [];

    var m = a2D.length;
    var n = a2D[0].length;

    // var a = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    var a = [].concat(...a2D); //convert 2d array to 1d 
    var a_size = [m,n];
    
    // Create TypedArrays
    var A = new Float64Array(a);
    var A_size = new Int32Array(a_size);
    
    var U = new Float64Array(m*m);
    var U_size = new Int32Array(2);
    
    // Move Data to Heap
    var Abytes = arrayToHeap(A,module);
    var A_sizebytes = arrayToHeap(A_size,module);

    var Ubytes = arrayToHeap(U,module);
    var U_sizebytes = arrayToHeap(U_size,module);

    module._getLeftNull_initialize();
    module._getLeftNull(
            Abytes.byteOffset, A_sizebytes.byteOffset, 
            Ubytes.byteOffset, U_sizebytes.byteOffset,)
    module._getLeftNull_terminate();

    //  Copy Data from Heap
    U = heapToFloat64Array(Ubytes, U);
    u = Array.from(U);
    U_size = heapToInt32Array(U_sizebytes, U_size);
    u_size = Array.from(U_size);

    // Free Data from Heap
    freeArray(Abytes,module);
    freeArray(A_sizebytes,module);
    freeArray(Ubytes,module);
    freeArray(U_sizebytes,module);
    
    // Display Results
    // console.log("u");
    // console.log(u);
    // console.log("u_size");
    // console.log(u_size);

    // Reshape to a 2D array
    var out = [];
    for(let i=0; i<u_size[0]; i++){
        out[i] = [];
        for(let j=0; j<u_size[1]; j++){
            out[i][j] = u[i*u_size[1]+j];
            // console.log(u[i*u_size[1]+j])
        }
    }

    console.log('wasm end')

    return {"u": u, "u_size": u_size, "out": out}
}